import { Deserializable } from './deserializable.model';

export class MultiAdminUserData implements Deserializable<MultiAdminUserData> {
  public user_id: number;
  public job_id: number;
  public email: string;
  public web_sync_id: number;
  public syncus_sync_id: number;
  public display_name: string;
  public user_status_id: number;
  public user_status_str: string;
  public disk_usage_bytes: number;
  public disk_limit_bytes: number;
  public disk_usage_percent: number;
  public last_filesync_time: number;
  public has_password_reset: number;
  public roles: string[];
  public isExpired?: boolean;
  public active?: boolean;
  public isLegacyToCNC?: boolean;

  public deserialize(params: any): MultiAdminUserData {
    for (const [key, val] of Object.entries(params)) {
      if (key in this) {
        this[key] = val;
      }
    }
    return this;
  }
}
